/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClusterRestrictionDetails } from '../models';
// @ts-ignore
import type { ListClusterRestrictionsResponse } from '../models';
// @ts-ignore
import type { ListRestrictionSilencesResponse } from '../models';
// @ts-ignore
import type { PreviewRestrictionSilenceResponse } from '../models';
// @ts-ignore
import type { RestrictionSilence } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ClusterScoreAPIApi - axios parameter creator
 * @export
 */
export const ClusterScoreAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a restriction silence rule. Idempotent: creating an identical rule returns the existing one.
         * @summary Creates a restriction silence
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {RestrictionSilence} restrictionSilence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPICreateRestrictionSilence: async (organizationId: string, clusterId: string, restrictionSilence: RestrictionSilence, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clusterScoreAPICreateRestrictionSilence', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('clusterScoreAPICreateRestrictionSilence', 'clusterId', clusterId)
            // verify required parameter 'restrictionSilence' is not null or undefined
            assertParamExists('clusterScoreAPICreateRestrictionSilence', 'restrictionSilence', restrictionSilence)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/restriction-silences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restrictionSilence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a restriction silence rule by ID.
         * @summary Deletes a restriction silence
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} id ID of the silence rule to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIDeleteRestrictionSilence: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clusterScoreAPIDeleteRestrictionSilence', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('clusterScoreAPIDeleteRestrictionSilence', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clusterScoreAPIDeleteRestrictionSilence', 'id', id)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/restriction-silences/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns details of a restriction.
         * @summary Returns details of a cluster restriction
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [resourceName] Name of the resource.
         * @param {string} [resourceKind] Kind of the resource.
         * @param {string} [resourceNamespace] Namespace of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIGetClusterRestrictionDetails: async (organizationId: string, clusterId: string, resourceName?: string, resourceKind?: string, resourceNamespace?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clusterScoreAPIGetClusterRestrictionDetails', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('clusterScoreAPIGetClusterRestrictionDetails', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/restriction-details`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }

            if (resourceKind !== undefined) {
                localVarQueryParameter['resourceKind'] = resourceKind;
            }

            if (resourceNamespace !== undefined) {
                localVarQueryParameter['resourceNamespace'] = resourceNamespace;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns restrictions for cluster.
         * @summary Returns restrictions for cluster
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ClusterScoreAPIListClusterRestrictionsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {Array<string>} [filterResourceNames] Filter by resource names.
         * @param {Array<string>} [filterResourceKinds] Filter by resource kinds.
         * @param {Array<string>} [filterResourceNamespaces] Filter by resource namespaces.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIListClusterRestrictions: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ClusterScoreAPIListClusterRestrictionsSortOrderEnum, filterResourceNames?: Array<string>, filterResourceKinds?: Array<string>, filterResourceNamespaces?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clusterScoreAPIListClusterRestrictions', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('clusterScoreAPIListClusterRestrictions', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (filterResourceNames) {
                localVarQueryParameter['filter.resourceNames'] = filterResourceNames;
            }

            if (filterResourceKinds) {
                localVarQueryParameter['filter.resourceKinds'] = filterResourceKinds;
            }

            if (filterResourceNamespaces) {
                localVarQueryParameter['filter.resourceNamespaces'] = filterResourceNamespaces;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists silence rules hiding restriction issues for the cluster.
         * @summary Lists restriction silences for cluster
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIListRestrictionSilences: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clusterScoreAPIListRestrictionSilences', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('clusterScoreAPIListRestrictionSilences', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/restriction-silences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Previews how many workloads a potential silence rule would affect.  All filter fields are optional; empty = wildcard. An empty rule previews  all workloads with any restriction.
         * @summary Previews the number of workloads affected by a potential restriction silence
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [workloadName] Workload name. Empty &#x3D; any workload.
         * @param {string} [workloadKind] Workload kind (e.g. Deployment). Empty &#x3D; any kind.
         * @param {string} [namespace] Namespace. Empty &#x3D; any namespace.
         * @param {string} [restrictionType] Restriction type (e.g. missing_probes). Empty &#x3D; any type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIPreviewRestrictionSilence: async (organizationId: string, clusterId: string, workloadName?: string, workloadKind?: string, namespace?: string, restrictionType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clusterScoreAPIPreviewRestrictionSilence', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('clusterScoreAPIPreviewRestrictionSilence', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/restriction-silences:preview`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workloadName !== undefined) {
                localVarQueryParameter['workloadName'] = workloadName;
            }

            if (workloadKind !== undefined) {
                localVarQueryParameter['workloadKind'] = workloadKind;
            }

            if (namespace !== undefined) {
                localVarQueryParameter['namespace'] = namespace;
            }

            if (restrictionType !== undefined) {
                localVarQueryParameter['restrictionType'] = restrictionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClusterScoreAPIApi - functional programming interface
 * @export
 */
export const ClusterScoreAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClusterScoreAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a restriction silence rule. Idempotent: creating an identical rule returns the existing one.
         * @summary Creates a restriction silence
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {RestrictionSilence} restrictionSilence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterScoreAPICreateRestrictionSilence(organizationId: string, clusterId: string, restrictionSilence: RestrictionSilence, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestrictionSilence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterScoreAPICreateRestrictionSilence(organizationId, clusterId, restrictionSilence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClusterScoreAPIApi.clusterScoreAPICreateRestrictionSilence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a restriction silence rule by ID.
         * @summary Deletes a restriction silence
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} id ID of the silence rule to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterScoreAPIDeleteRestrictionSilence(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterScoreAPIDeleteRestrictionSilence(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClusterScoreAPIApi.clusterScoreAPIDeleteRestrictionSilence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns details of a restriction.
         * @summary Returns details of a cluster restriction
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [resourceName] Name of the resource.
         * @param {string} [resourceKind] Kind of the resource.
         * @param {string} [resourceNamespace] Namespace of the resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterScoreAPIGetClusterRestrictionDetails(organizationId: string, clusterId: string, resourceName?: string, resourceKind?: string, resourceNamespace?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterRestrictionDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterScoreAPIGetClusterRestrictionDetails(organizationId, clusterId, resourceName, resourceKind, resourceNamespace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClusterScoreAPIApi.clusterScoreAPIGetClusterRestrictionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns restrictions for cluster.
         * @summary Returns restrictions for cluster
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ClusterScoreAPIListClusterRestrictionsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {Array<string>} [filterResourceNames] Filter by resource names.
         * @param {Array<string>} [filterResourceKinds] Filter by resource kinds.
         * @param {Array<string>} [filterResourceNamespaces] Filter by resource namespaces.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterScoreAPIListClusterRestrictions(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ClusterScoreAPIListClusterRestrictionsSortOrderEnum, filterResourceNames?: Array<string>, filterResourceKinds?: Array<string>, filterResourceNamespaces?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListClusterRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterScoreAPIListClusterRestrictions(organizationId, clusterId, pageLimit, pageCursor, sortField, sortOrder, filterResourceNames, filterResourceKinds, filterResourceNamespaces, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClusterScoreAPIApi.clusterScoreAPIListClusterRestrictions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists silence rules hiding restriction issues for the cluster.
         * @summary Lists restriction silences for cluster
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterScoreAPIListRestrictionSilences(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRestrictionSilencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterScoreAPIListRestrictionSilences(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClusterScoreAPIApi.clusterScoreAPIListRestrictionSilences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Previews how many workloads a potential silence rule would affect.  All filter fields are optional; empty = wildcard. An empty rule previews  all workloads with any restriction.
         * @summary Previews the number of workloads affected by a potential restriction silence
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [workloadName] Workload name. Empty &#x3D; any workload.
         * @param {string} [workloadKind] Workload kind (e.g. Deployment). Empty &#x3D; any kind.
         * @param {string} [namespace] Namespace. Empty &#x3D; any namespace.
         * @param {string} [restrictionType] Restriction type (e.g. missing_probes). Empty &#x3D; any type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterScoreAPIPreviewRestrictionSilence(organizationId: string, clusterId: string, workloadName?: string, workloadKind?: string, namespace?: string, restrictionType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewRestrictionSilenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterScoreAPIPreviewRestrictionSilence(organizationId, clusterId, workloadName, workloadKind, namespace, restrictionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClusterScoreAPIApi.clusterScoreAPIPreviewRestrictionSilence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClusterScoreAPIApi - factory interface
 * @export
 */
export const ClusterScoreAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClusterScoreAPIApiFp(configuration)
    return {
        /**
         * Creates a restriction silence rule. Idempotent: creating an identical rule returns the existing one.
         * @summary Creates a restriction silence
         * @param {ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPICreateRestrictionSilence(requestParameters: ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<RestrictionSilence> {
            return localVarFp.clusterScoreAPICreateRestrictionSilence(requestParameters.organizationId, requestParameters.clusterId, requestParameters.restrictionSilence, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a restriction silence rule by ID.
         * @summary Deletes a restriction silence
         * @param {ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIDeleteRestrictionSilence(requestParameters: ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clusterScoreAPIDeleteRestrictionSilence(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns details of a restriction.
         * @summary Returns details of a cluster restriction
         * @param {ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIGetClusterRestrictionDetails(requestParameters: ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterRestrictionDetails> {
            return localVarFp.clusterScoreAPIGetClusterRestrictionDetails(requestParameters.organizationId, requestParameters.clusterId, requestParameters.resourceName, requestParameters.resourceKind, requestParameters.resourceNamespace, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns restrictions for cluster.
         * @summary Returns restrictions for cluster
         * @param {ClusterScoreAPIApiClusterScoreAPIListClusterRestrictionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIListClusterRestrictions(requestParameters: ClusterScoreAPIApiClusterScoreAPIListClusterRestrictionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListClusterRestrictionsResponse> {
            return localVarFp.clusterScoreAPIListClusterRestrictions(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.filterResourceNames, requestParameters.filterResourceKinds, requestParameters.filterResourceNamespaces, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists silence rules hiding restriction issues for the cluster.
         * @summary Lists restriction silences for cluster
         * @param {ClusterScoreAPIApiClusterScoreAPIListRestrictionSilencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIListRestrictionSilences(requestParameters: ClusterScoreAPIApiClusterScoreAPIListRestrictionSilencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRestrictionSilencesResponse> {
            return localVarFp.clusterScoreAPIListRestrictionSilences(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Previews how many workloads a potential silence rule would affect.  All filter fields are optional; empty = wildcard. An empty rule previews  all workloads with any restriction.
         * @summary Previews the number of workloads affected by a potential restriction silence
         * @param {ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterScoreAPIPreviewRestrictionSilence(requestParameters: ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewRestrictionSilenceResponse> {
            return localVarFp.clusterScoreAPIPreviewRestrictionSilence(requestParameters.organizationId, requestParameters.clusterId, requestParameters.workloadName, requestParameters.workloadKind, requestParameters.namespace, requestParameters.restrictionType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clusterScoreAPICreateRestrictionSilence operation in ClusterScoreAPIApi.
 * @export
 * @interface ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilenceRequest
 */
export interface ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilenceRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilence
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilence
     */
    readonly clusterId: string

    /**
     * 
     * @type {RestrictionSilence}
     * @memberof ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilence
     */
    readonly restrictionSilence: RestrictionSilence
}

/**
 * Request parameters for clusterScoreAPIDeleteRestrictionSilence operation in ClusterScoreAPIApi.
 * @export
 * @interface ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilenceRequest
 */
export interface ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilenceRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilence
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilence
     */
    readonly clusterId: string

    /**
     * ID of the silence rule to delete.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilence
     */
    readonly id: string
}

/**
 * Request parameters for clusterScoreAPIGetClusterRestrictionDetails operation in ClusterScoreAPIApi.
 * @export
 * @interface ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetailsRequest
 */
export interface ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetailsRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetails
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetails
     */
    readonly clusterId: string

    /**
     * Name of the resource.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetails
     */
    readonly resourceName?: string

    /**
     * Kind of the resource.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetails
     */
    readonly resourceKind?: string

    /**
     * Namespace of the resource.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetails
     */
    readonly resourceNamespace?: string
}

/**
 * Request parameters for clusterScoreAPIListClusterRestrictions operation in ClusterScoreAPIApi.
 * @export
 * @interface ClusterScoreAPIApiClusterScoreAPIListClusterRestrictionsRequest
 */
export interface ClusterScoreAPIApiClusterScoreAPIListClusterRestrictionsRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly sortOrder?: ClusterScoreAPIListClusterRestrictionsSortOrderEnum

    /**
     * Filter by resource names.
     * @type {Array<string>}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly filterResourceNames?: Array<string>

    /**
     * Filter by resource kinds.
     * @type {Array<string>}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly filterResourceKinds?: Array<string>

    /**
     * Filter by resource namespaces.
     * @type {Array<string>}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListClusterRestrictions
     */
    readonly filterResourceNamespaces?: Array<string>
}

/**
 * Request parameters for clusterScoreAPIListRestrictionSilences operation in ClusterScoreAPIApi.
 * @export
 * @interface ClusterScoreAPIApiClusterScoreAPIListRestrictionSilencesRequest
 */
export interface ClusterScoreAPIApiClusterScoreAPIListRestrictionSilencesRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListRestrictionSilences
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListRestrictionSilences
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListRestrictionSilences
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIListRestrictionSilences
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for clusterScoreAPIPreviewRestrictionSilence operation in ClusterScoreAPIApi.
 * @export
 * @interface ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilenceRequest
 */
export interface ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilenceRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilence
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilence
     */
    readonly clusterId: string

    /**
     * Workload name. Empty &#x3D; any workload.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilence
     */
    readonly workloadName?: string

    /**
     * Workload kind (e.g. Deployment). Empty &#x3D; any kind.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilence
     */
    readonly workloadKind?: string

    /**
     * Namespace. Empty &#x3D; any namespace.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilence
     */
    readonly namespace?: string

    /**
     * Restriction type (e.g. missing_probes). Empty &#x3D; any type.
     * @type {string}
     * @memberof ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilence
     */
    readonly restrictionType?: string
}

/**
 * ClusterScoreAPIApi - object-oriented interface
 * @export
 * @class ClusterScoreAPIApi
 * @extends {BaseAPI}
 */
export class ClusterScoreAPIApi extends BaseAPI {
    /**
     * Creates a restriction silence rule. Idempotent: creating an identical rule returns the existing one.
     * @summary Creates a restriction silence
     * @param {ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterScoreAPIApi
     */
    public clusterScoreAPICreateRestrictionSilence(requestParameters: ClusterScoreAPIApiClusterScoreAPICreateRestrictionSilenceRequest, options?: RawAxiosRequestConfig) {
        return ClusterScoreAPIApiFp(this.configuration).clusterScoreAPICreateRestrictionSilence(requestParameters.organizationId, requestParameters.clusterId, requestParameters.restrictionSilence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a restriction silence rule by ID.
     * @summary Deletes a restriction silence
     * @param {ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterScoreAPIApi
     */
    public clusterScoreAPIDeleteRestrictionSilence(requestParameters: ClusterScoreAPIApiClusterScoreAPIDeleteRestrictionSilenceRequest, options?: RawAxiosRequestConfig) {
        return ClusterScoreAPIApiFp(this.configuration).clusterScoreAPIDeleteRestrictionSilence(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns details of a restriction.
     * @summary Returns details of a cluster restriction
     * @param {ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterScoreAPIApi
     */
    public clusterScoreAPIGetClusterRestrictionDetails(requestParameters: ClusterScoreAPIApiClusterScoreAPIGetClusterRestrictionDetailsRequest, options?: RawAxiosRequestConfig) {
        return ClusterScoreAPIApiFp(this.configuration).clusterScoreAPIGetClusterRestrictionDetails(requestParameters.organizationId, requestParameters.clusterId, requestParameters.resourceName, requestParameters.resourceKind, requestParameters.resourceNamespace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns restrictions for cluster.
     * @summary Returns restrictions for cluster
     * @param {ClusterScoreAPIApiClusterScoreAPIListClusterRestrictionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterScoreAPIApi
     */
    public clusterScoreAPIListClusterRestrictions(requestParameters: ClusterScoreAPIApiClusterScoreAPIListClusterRestrictionsRequest, options?: RawAxiosRequestConfig) {
        return ClusterScoreAPIApiFp(this.configuration).clusterScoreAPIListClusterRestrictions(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.filterResourceNames, requestParameters.filterResourceKinds, requestParameters.filterResourceNamespaces, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists silence rules hiding restriction issues for the cluster.
     * @summary Lists restriction silences for cluster
     * @param {ClusterScoreAPIApiClusterScoreAPIListRestrictionSilencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterScoreAPIApi
     */
    public clusterScoreAPIListRestrictionSilences(requestParameters: ClusterScoreAPIApiClusterScoreAPIListRestrictionSilencesRequest, options?: RawAxiosRequestConfig) {
        return ClusterScoreAPIApiFp(this.configuration).clusterScoreAPIListRestrictionSilences(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Previews how many workloads a potential silence rule would affect.  All filter fields are optional; empty = wildcard. An empty rule previews  all workloads with any restriction.
     * @summary Previews the number of workloads affected by a potential restriction silence
     * @param {ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterScoreAPIApi
     */
    public clusterScoreAPIPreviewRestrictionSilence(requestParameters: ClusterScoreAPIApiClusterScoreAPIPreviewRestrictionSilenceRequest, options?: RawAxiosRequestConfig) {
        return ClusterScoreAPIApiFp(this.configuration).clusterScoreAPIPreviewRestrictionSilence(requestParameters.organizationId, requestParameters.clusterId, requestParameters.workloadName, requestParameters.workloadKind, requestParameters.namespace, requestParameters.restrictionType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ClusterScoreAPIListClusterRestrictionsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type ClusterScoreAPIListClusterRestrictionsSortOrderEnum = typeof ClusterScoreAPIListClusterRestrictionsSortOrderEnum[keyof typeof ClusterScoreAPIListClusterRestrictionsSortOrderEnum];
